import React from "react";
import {
    WorkContainer, 
    WorkVideo, 
    WorkVideoTitle, 
    WorkVideoSubtitle, 
    WorkVideoTitleMobile, 
    WorkCTASection, 
    WorkButton, 
    WorkSection,
    VideoFrame

} from "./WorkElements";
import { useNavigate } from "react-router-dom";

const Work = () => {
    const navigate = useNavigate();

    return (
        <>
            <WorkContainer>
                <WorkSection id="corporate">
                <WorkVideoTitle>P R O M O T I O N A L + C O R P O R A T E</WorkVideoTitle>
                <WorkVideoTitleMobile style={{marginTop: '40px'}}>P R O M O T I O N A L</WorkVideoTitleMobile>
                <WorkVideoTitleMobile>C O R P O R A T E</WorkVideoTitleMobile>
                <WorkVideoSubtitle>Promotional & Corporate videos for companies looking to attract customers and investors</WorkVideoSubtitle>
                {/*KutrybX Launch - Boost Your Wellness, Enhance Your Story*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=drOA09sM9z0" /></VideoFrame>
                <br />
                <br />
                {/*Secure Garages*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=7ca40Z2azvI" /></VideoFrame>
                <br />
                <br />
                {/*GFF Dance Studio*/}
                <VideoFrame><WorkVideo controls url="https://youtu.be/mUDFGwS3MpM" /></VideoFrame>
                <br />
                <br />
                {/*Iwona beauty clinic*/}
                <VideoFrame><WorkVideo controls url="https://youtu.be/iY1sSU2GSb8" /></VideoFrame>
                <br />
                <br />
                {/*Citizens Advice - Social Prescribing Team*/}
                <VideoFrame><WorkVideo controls url="https://youtu.be/sfGKFWx2vhA" /></VideoFrame>
                </WorkSection>

                <WorkSection id="events">
                <WorkVideoTitle>E V E N T S</WorkVideoTitle>
                <WorkVideoTitleMobile style={{marginTop: '40px'}}>E V E N T</WorkVideoTitleMobile>
                <WorkVideoSubtitle>Event videos that encapsulate the atmosphere, energy, and highlights of your event, creating lasting impressions.</WorkVideoSubtitle>
                {/*Elvisy*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=xq2-4zpWBaw" /></VideoFrame>
                <br />
                <br />
                {/*Womens Club*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=jgutK7HLae4" /></VideoFrame>
                <br />
                <br />
                {/*GFF 10-lecie*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=DCCsnDZLrsk" /></VideoFrame>
                <br />
                <br />
                {/*Bristol Purge*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=UiqblNPVmwU" /></VideoFrame>
                <br />
                <br />
                {/*Bieszczady*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=YmtxVLDUkdM" /></VideoFrame>
                </WorkSection>

                <WorkSection id="wedding">
                <WorkVideoTitle>W E D D I N G</WorkVideoTitle>
                <WorkVideoTitleMobile style={{marginTop: '40px'}}>W E D D I N G</WorkVideoTitleMobile>
                <WorkVideoSubtitle>Wedding films that will properly touch your emotions, taking you back to that unforgettable day.</WorkVideoSubtitle>
                {/*Beth i Phillip*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=a--J1kZxwC4" /></VideoFrame>
                <br />
                <br />
                {/*Dorota*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=2vrFISkZoMc" /></VideoFrame>
                <br />
                <br />
                {/*Kuba i Kasia*/}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=Uec9lYG_bnU" /></VideoFrame>
                </WorkSection>
                
                <WorkSection id="music">
                <WorkVideoTitle>M U S I C</WorkVideoTitle>
                <WorkVideoTitleMobile style={{marginTop: '40px'}}>M U S I C</WorkVideoTitleMobile>
                <WorkVideoSubtitle>Music videos that bring the value you care about.</WorkVideoSubtitle>
                {/*Robson */}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=I1yY5zcnsQE" /></VideoFrame>
                <br />
                <br />
                {/*Dont Koks */}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=8y1St65Dm8Q" /></VideoFrame>
                <br />
                <br />
                {/*Pirate Studio */}
                <VideoFrame><WorkVideo controls url="https://www.youtube.com/watch?v=8zdjjFczqlc" /></VideoFrame>
                </WorkSection>

                <WorkCTASection>
                    <WorkButton onClick={() => navigate("/")}>
                    Choose Your Package
                    </WorkButton>
                    <WorkButton onClick={() => navigate("/contact")}>
                    Request a Custom Quote
                    </WorkButton>
                </WorkCTASection>

            </WorkContainer>
        </>
    )
}

export default Work;

